// extracted by mini-css-extract-plugin
module.exports = {"block":"table-empty_block__1A2SD","content":"table-empty_content__3PGdB"};